
/** 字段转换 */
export const isOriginCenter = [-1, 1, '否', '是']
export const scanType = ['卸车', '装车', '分拨到车', '分拨发车']

export const ds = ['actual_load_unload_result', 'route_plan_result']
